export default __webpack_public_path__ + "static/media/lasVegasRaiders@2x.4876657b.jpg";